export const AspectRatios = {
  "1:1": 1,
  "16:19": 16 / 9,
  "4:3": 4 / 3,
  "3:2": 3 / 2,
  "21:9": 21 / 9,
  free: 0, // Placeholder for custom aspect ratios
} as const;
